const DiscoverGeneric = () =>
  import(
    /*webpackChunkName: "DiscoverGeneric"*/ "../../../views/generic/DiscoverGeneric.vue"
  );
export default {
  path: "discover",
  name: "discover",
  alias: ["descubre", "descubre/:country", "discover/:country"],
  component: DiscoverGeneric,
  props: true,
  meta: {
    requiresAuth: false,
    requiresEntitlement: false,
    isAmbiguous: true,
  },
};
